import en from './en/en';
import fr from './fr/fr';

export default {
    en,
    fr,
};
